import cs from 'classnames';

import { FormattedOption } from 'types/dictionaries';

import { SKILL_MATCH_ICON_SIZE_PX } from 'constants/uiSettings';

import { ReactComponent as MinusCircleIcon } from 'assets/icons/minus-circle.svg';
import { ReactComponent as TickCircleIcon } from 'assets/icons/tick-circle.svg';

import styles from './SkillsetItem.module.scss';

interface SkillsetItemProps {
  skillset: string;
  skillsetsMatches: string[];
  skillsetsDictionary: FormattedOption[];
  colorVarName?: string;
}

const SkillsetItem = ({
  skillset,
  skillsetsMatches,
  skillsetsDictionary,
  colorVarName
}: SkillsetItemProps) => {
  const isSkillsetMatch = skillsetsMatches.includes(skillset);
  const label = skillsetsDictionary.find(
    (dictionaryItem) => dictionaryItem.value === skillset
  )?.label;

  return (
    <div className={styles.wrapper}>
      <div
        className={cs(styles.iconWrapper, { [styles.match]: isSkillsetMatch })}
      >
        {isSkillsetMatch ? (
          <TickCircleIcon
            width={SKILL_MATCH_ICON_SIZE_PX}
            height={SKILL_MATCH_ICON_SIZE_PX}
            color={`var(${colorVarName})`}
          />
        ) : (
          <MinusCircleIcon
            width={SKILL_MATCH_ICON_SIZE_PX}
            height={SKILL_MATCH_ICON_SIZE_PX}
          />
        )}
      </div>
      <span
        className={cs(styles.text, { [styles.match]: isSkillsetMatch })}
        style={isSkillsetMatch ? { color: `var(${colorVarName})` } : {}}
      >
        {label}
      </span>
    </div>
  );
};

export default SkillsetItem;
